import { createContext, useState } from 'react'
import clienteAxios from '../config/clienteAxios'
import toast from 'react-hot-toast'

const PgiModulesContext = createContext()

const PgiModulesProvider = ({ children }) => {
  const [modules, setModules] = useState([])
  const [bloqueInfo, setBloqueInfo] = useState({});
  const [modulesBloqueInfo, setModulesBloqueInfo] = useState(bloqueInfo)
  const [newModules, setNewModules] = useState([])

  const getModulesByParams = async (params) => {
    try {
      const { data } = await clienteAxios.get(`/module`, {params: params})
      setNewModules(data.modulesByParam)
      return data.modulesByParam
    } catch (error) {
      toast.error(error)
    }
  }

  const handleVisibility = (module, page) => {
    setModules(
      modules.map((item) => {
        if (item._id === module._id) {
          if (item.visible.find((value) => value === page)) {
            const index = item.visible.indexOf(page)
            item.visible.splice(index, 1)
          } else {
            item.visible.push(page)
          }
        }
        return item
      })
    )
  }

  const handleModuleUpdate = async () => {
      try {
        const promises =  modules.map((item) => 
        clienteAxios.put('/module', item)
        );
        const results = await Promise.all(promises);
        toast.success('Se actualizó el módulo')
      } catch (error) {
        toast.error('error')
      }

  }

  return (
    <PgiModulesContext.Provider
      value={{
        modules,
        setModules,
        getModulesByParams,
        handleVisibility,
        handleModuleUpdate,
        setModulesBloqueInfo,
        modulesBloqueInfo,
        setBloqueInfo,
        bloqueInfo,
      }}
    >
      {children}
    </PgiModulesContext.Provider>
  )
}

export { PgiModulesProvider }

export default PgiModulesContext
